import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  container: {
    backgroundColor: colors.backgroundL2,
    overflow: 'hidden',

    variants: {
      variant: {
        text: {
          borderRadius: theme.borderRadius.s,
        },
        circular: {
          borderRadius: theme.borderRadius.full, // full circle
        },
        rectangular: {
          borderRadius: theme.borderRadius.l,
        },
      },
    },
  },
  children: {
    opacity: 0,
  },
}));
